import { authApi } from "./index";

/**
 * Fetches professions, grouped by category and sorted by popularity (UsageCount DESC).
 * @param {string} [search] - Optional search query
 * @param {string} [category] - Optional category filter
 * @param {boolean} [flat=false] - Whether to return an ungrouped flat list
 * @param {number} [pageNumber=1] - Page number (defaults to 1)
 * @param {number} [pageSize=100] - Page size (defaults to 100, max allowed by backend)
 */
export const getProfessions = async (search, category, flat = false, pageNumber = 1, pageSize = 100) => {
  try {
    const params = { pageNumber, pageSize };
    if (search) params.search = search;
    if (category) params.category = category;
    if (flat) params.flat = true;
    const response = await authApi.get("/Professions", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Retrieves the titles/professions chosen by a user.
 * @param {string} [userId] - Optional userId (defaults to current token user)
 */
export const getUserProfessions = async (userId) => {
  try {
    const endpoint = userId ? `/Professions/user/${userId}` : "/Professions/user";
    const response = await authApi.get(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Saves/updates user's selected professions and provisions eligible profession communities.
 * @param {string[]} professions - Array of profession titles
 * @param {string} [userId] - Optional userId
 */
export const saveUserProfessions = async (professions, userId) => {
  try {
    const payload = {
      professions: Array.isArray(professions) ? professions : [],
      ...(userId ? { userId } : {})
    };
    const response = await authApi.post("/Professions/user", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
